@let techniques = store.getPaginated();

<section class="px-xs !py-lg h-full bg-white" hlmCard>
  <div class="px-md flex items-center justify-between">
    <h3 hlmCardTitle>Liste des techniques d'animation</h3>
    <div hlmCardAction>
      <button (click)="ajouterTechnique()" hlmBtn variant="secondary">
        <ng-icon name="lucidePlus" />
        Créer une nouvelle technique d'animation
      </button>
    </div>
  </div>
  <div class="gap-xl grid" hlmCardContent>
    <div hlmTableContainer>
      <table hlmTable>
        <thead hlmTHead>
          <tr hlmTr>
            <th hlmTh>Libellé</th>
            <th hlmTh>Lien</th>
            <th hlmTh>Actions</th>
          </tr>
        </thead>
        <tbody hlmTBody>
          @for (item of techniques; track item.id) {
            <tr hlmTr>
              <td hlmTd>{{ item.libelle }}</td>
              <td hlmTd>
                <a [href]="item.lien" hlmBtn variant="link" target="_blank">{{ item.lien }}</a>
              </td>
              <td hlmTd>
                <button
                  [hlmDropdownMenuTrigger]="menu"
                  [hlmDropdownMenuTriggerData]="{ $implicit: item }"
                  (click)="$event.stopPropagation()"
                  hlmBtn
                  variant="ghost"
                  size="icon"
                >
                  <ng-icon name="lucideEllipsisVertical" />
                </button>
              </td>
            </tr>
          } @empty {
            <tr hlmTr>
              <td hlmTd colspan="4">Aucune techniques d'animation ne correspond à votre recherche</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <app-paginateur [store]="store" />
  </div>
</section>

<ng-template #menu let-ctx>
  <hlm-dropdown-menu>
    <hlm-dropdown-menu-group>
      <button (triggered)="modifierTechnique(ctx)" hlmDropdownMenuItem>
        <ng-icon hlm name="lucidePen" size="sm" />
        Modifier la technique d'animation
      </button>
      <button (triggered)="supprimerTechnique(ctx)" hlmDropdownMenuItem>
        <ng-icon hlm name="lucideTrash" size="sm" />
        Supprimer la technique d'animation
      </button>
    </hlm-dropdown-menu-group>
  </hlm-dropdown-menu>
</ng-template>
